<template>
  <div id="app">
    <v-card class="elevation-0">
      <div style="font-size: 1.25rem" class="px-4 font-weight-bold">
        {{ $vuetify.lang.t("$vuetify.ai_response.recommendation_endpoints") }}
      </div>
      <v-row class="ml-2">
        <v-col cols="8" xs="12">
          <v-select v-model="selectedEndpoint" :items="RECOMMENDATION_ENDPOINTS"
            :label='$vuetify.lang.t("$vuetify.ai_response.select_endpoint")' outlined required
            item-text="endpoint_name"
            item-value="endpoint_value"
          >
          </v-select>
        </v-col>
      </v-row>

      <template v-if="selectedEndpoint === '/v1/items/recommend'">
          <ItemsRecommend ref="itemRecommendRef" :mapper="mapper"/>
      </template>
      <template v-if="selectedEndpoint === '/v1/items/purchased/together'">
          <ItemsPurchasedTogether ref="itemPurchaseTogetherRef" :mapper="mapper"/>
      </template>
      <template v-if="selectedEndpoint === '/v1/users/recommend'">
          <UsersRecommend ref="itemPurchaseTogetherRef" :mapper="mapper" :catalogItems="catalogItems"  />
      </template>
      <template v-if="selectedEndpoint === '/v1/items/trending'">
          <TrendingItems ref="itemPurchaseTogetherRef" :mapper="mapper" :catalogItems="catalogItems"  />
      </template>
      <template v-if="selectedEndpoint === '/v1/items/image/recommend'">
          <ItemsImageRecommend ref="itemPurchaseTogetherRef" :mapper="mapper" :catalogItems="catalogItems"  />
      </template>
      <template v-if="selectedEndpoint === '/v1/users/search/recommend'">
          <UsersSearchRecommend ref="itemPurchaseTogetherRef" :mapper="mapper" :catalogItems="catalogItems"  />
      </template>
      <template v-if="selectedEndpoint === '/v1/questionnaire/recommend'">
          <QuestionnaireRecommend ref="itemPurchaseTogetherRef" :mapper="mapper" :catalogItems="catalogItems"  />
      </template>
    </v-card>
  </div>
</template>

<script>
import ItemsRecommend from "@/components/Projects/Recommendation/Endpoints/ItemsRecommend"
import ItemsPurchasedTogether from "@/components/Projects/Recommendation/Endpoints/ItemsPurchasedTogether"
import UsersRecommend from "@/components/Projects/Recommendation/Endpoints/UsersRecommend"
import TrendingItems from "@/components/Projects/Recommendation/Endpoints/TrendingItems"
import ItemsImageRecommend from "@/components/Projects/Recommendation/Endpoints/ItemsImageRecommend"
import UsersSearchRecommend from "@/components/Projects/Recommendation/Endpoints/UsersSearchRecommend"
import QuestionnaireRecommend from "@/components/Projects/Recommendation/Endpoints/QuestionnaireRecommend"
import { GET_MAPPER, GET_CATALOG_ITEMS, ADD_ALERT } from "@/store/_actiontypes";
import { mapState, mapActions } from "vuex";


export default {
  components: {
    ItemsRecommend,
    ItemsPurchasedTogether,
    UsersRecommend,
    TrendingItems,
    ItemsImageRecommend,
    UsersSearchRecommend,
    QuestionnaireRecommend
  },
  
  data() {
    return {
      selectedEndpoint: "",
      mapper : {},
      catalogKeys: [],
      catalogItems: [],
      RECOMMENDATION_ENDPOINTS: [
        {
          endpoint_name: this.$vuetify.lang.t("$vuetify.ai_response.items_recommend"),
          endpoint_value: "/v1/items/recommend"
        },
        {
          endpoint_name: this.$vuetify.lang.t("$vuetify.ai_response.items_purchased_together"),
          endpoint_value: "/v1/items/purchased/together"
        },
        {
          endpoint_name: this.$vuetify.lang.t("$vuetify.ai_response.users_recommend"),
          endpoint_value: "/v1/users/recommend"
        },
        {
          endpoint_name: this.$vuetify.lang.t("$vuetify.ai_response.items_trending"),
          endpoint_value: "/v1/items/trending"
        },
        {
          endpoint_name: this.$vuetify.lang.t("$vuetify.ai_response.items_image_recommend"),
          endpoint_value: "/v1/items/image/recommend"
        },
        {
          endpoint_name: this.$vuetify.lang.t("$vuetify.ai_response.users_search_recommend"),
          endpoint_value: "/v1/users/search/recommend"
        },
        {
          endpoint_name: this.$vuetify.lang.t("$vuetify.ai_response.questionnaire_recommend"),
          endpoint_value: "/v1/questionnaire/recommend"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      selectedProject: (state) => state.project.selectedProject,
      user: (state) => state.account.user
    }),
  },
  mounted() {
    this.getMapper()
    this.getCatalogItems()
  },
  methods: {
    ...mapActions("project", [GET_MAPPER]),
    ...mapActions("ai_response", [GET_CATALOG_ITEMS]),
    ...mapActions("alert", [ADD_ALERT]),
    getMapper() {
      this.getMapperFunction();
    }, 
    getMapperFunction() {
      this.GET_MAPPER({
        project_id: this.selectedProject.id,
      }).then(
        (response) => {
          this.mapper = response.data.detail.response
        },
        (error) => {
          console.error("error", error)
          if(error.status === 422){
            this.$store.dispatch(
                  `alert/${ADD_ALERT}`, {
                    message: JSON.stringify(error?.response?.data?.detail),
                    color: "error",
                  }, { root: true }
                );
          } else {
            this.$store.dispatch(
                  `alert/${ADD_ALERT}`, {
                    message: error?.response?.data?.detail?.response,
                    color: "error",
                  }, { root: true }
            );
          }
        }
      );

    },
    
    getCatalogItems(){
      this.getCatalogItemsFunction();
    },
    getCatalogItemsFunction(){
      this.GET_CATALOG_ITEMS({
        project_id: this.selectedProject.id,
      }).then(
        (response) => {
          this.catalogItems = response.data.detail.response?.items
          if (response?.data?.detail?.response?.next_scroll_id){
            this.$store.commit("project/CATALOG_SCROLL_ID_STACK", {
              action: 'push',
              value: response?.data?.detail?.response?.next_scroll_id
            });
          }
        },
        (error) => {
          console.error("error", error)
          if(error.status === 422){
            this.$store.dispatch(
                  `alert/${ADD_ALERT}`, {
                    message: JSON.stringify(error?.response?.data?.detail),
                    color: "error",
                  }, { root: true }
                );
          } else {
            this.$store.dispatch(
                  `alert/${ADD_ALERT}`, {
                    message: error?.response?.data?.detail?.response,
                    color: "error",
                  }, { root: true }
            );
          }
        }
      );
    }
  }
};
</script>

<style scoped>

</style>
